/* Cart availability.

   Shopify's checkout refuses an order when an item has no stock at the
   location serving the delivery address, but its message never names the
   item: "one or more items in your cart are not currently available".
   Customers guess, remove the wrong thing, and email support.

   This names the items before they reach checkout, on BOTH surfaces, and
   blocks the checkout button while an unavailable item is in the cart.

   ANCHORS - read out of this theme, not assumed. The class names here carry
   a literal '#' because the theme builds them from an NS variable
   (s_cart.liquid line 3: cn = '#' | append: NS), so '.cart' and '#cart' both
   fail and [class~="#cart-sidebar"] is the correct selector.

     cart page    [class~="#cart-sidebar"]      top of the sidebar, directly
                                                above Subtotal and the
                                                checkout button
     cart drawer  [data-ff-checkout-wrapper]    inserted above the checkout
                                                button

   RATE LIMIT - the previous version replaced window.fetch and re-ran the
   whole check on any request containing '/cart/'. One person adjusting a
   basket produced nine checks in fifteen seconds, each making three Shopify
   calls. Shopify allows two a second on this plan, so a busy store throttled
   and the banner silently stopped appearing - exactly when it was needed
   most. The unavailable list is now fetched once per page load and held in
   memory; cart changes re-read that list rather than asking the server. */
(function () {
  'use strict';

  var PROXY = '/apps/membership';
  var CART_SIDEBAR = '[class~="#cart-sidebar"]';
  var DRAWER_WRAPPER = '[data-ff-checkout-wrapper]';
  var BANNER_ID = 'ff-avail-banner';

  var unavailable = null;   /* cached for the page, keyed by variant id */
  var fetching = null;      /* in-flight promise, so parallel calls share it */
  var lastPostcode;         /* re-fetch when the customer's area changes */

  /* ---------------------------------------------------------------- style */
  if (!document.getElementById('ff-avail-css')) {
    var css = document.createElement('style');
    css.id = 'ff-avail-css';
    css.textContent = [
      '.ff-avail{background:#fef2f2;border:1px solid #f3c1c1;border-radius:8px;',
      'padding:14px 16px;margin:0 0 16px;font-size:13.5px;line-height:1.5;color:#1c1c1c}',
      '.ff-avail b{display:block;margin-bottom:8px;color:#c0392b;font-size:14px}',
      '.ff-avail ul{margin:0;padding:0;list-style:none}',
      '.ff-avail li{margin-bottom:8px;padding-bottom:8px;border-bottom:1px solid #f6d7d7}',
      '.ff-avail li:last-child{margin-bottom:0;padding-bottom:0;border-bottom:0}',
      '.ff-avail .ff-avail-name{font-weight:700}',
      '.ff-avail .ff-avail-where{display:block;color:#7a7a78;font-size:12px;margin-top:2px}',
      '.ff-avail .ff-avail-remove{display:inline-block;margin-top:5px;font-size:12px;',
      'color:#c0392b;text-decoration:underline;cursor:pointer;background:none;border:0;padding:0;',
      'font-family:inherit}',
      '.ff-avail .ff-avail-foot{margin:10px 0 0;font-size:12.5px;color:#7a7a78}',
      /* blocked checkout - only while an unavailable item is in the cart */
      '.ff-avail-blocked{opacity:.45;pointer-events:none}',
      '.ff-avail-blocked button,.ff-avail-blocked a,.ff-avail-blocked input[type="submit"]',
      '{cursor:not-allowed}'
    ].join('');
    document.head.appendChild(css);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  /* The delivery postcode, if the customer has given one. Without it the
     server only reports items out of stock at every hub, so a Cape Town
     customer is never blocked over Johannesburg stock. */
  /* The delivery postcode.

     Zapiet owns the postcode field on the cart page and stores the customer's
     selection as CART ATTRIBUTES, not in our own localStorage key - which is
     why a 2090 customer was being told about Cape Town stock. Cart attributes
     come back with /cart.js, so they are read from there first. Any attribute
     whose name mentions a postal or zip code is accepted, rather than guessing
     one exact key name. Our own membership gate key is the fallback. */
  function postcodeFrom(cart) {
    var attrs = (cart && cart.attributes) || {};
    for (var k in attrs) {
      if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
      if (!/post|zip/i.test(k)) continue;
      var d = String(attrs[k] || '').replace(/\D/g, '');
      if (d.length >= 4) return d.slice(0, 4);
    }
    try {
      var v = localStorage.getItem('ff_delivery_postcode');
      if (v) {
        var f = String(v).replace(/\D/g, '');
        if (f.length >= 4) return f.slice(0, 4);
      }
    } catch (e) {}
    return null;
  }

  /* ---------------------------------------------------------------- data */
  function load(variantIds, pc) {
    /* Re-fetch if the postcode has changed - the answer depends on it. */
    if (pc !== lastPostcode) { unavailable = null; lastPostcode = pc; }
    if (unavailable) return Promise.resolve(unavailable);
    if (fetching) return fetching;

    fetching = fetch(PROXY + '/cart-check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variant_ids: variantIds, postcode: pc })
    })
      .then(function (r) { return r.ok ? r.json() : { unavailable: [] }; })
      .then(function (d) {
        unavailable = {};
        (d.unavailable || []).forEach(function (u) {
          unavailable[u.variant_id] = u;
        });
        return unavailable;
      })
      .catch(function () {
        unavailable = {};
        return unavailable;
      })
      .then(function (r) { fetching = null; return r; });

    return fetching;
  }

  /* ---------------------------------------------------------------- render */
  function removeBanners() {
    var all = document.querySelectorAll('#' + BANNER_ID);
    Array.prototype.forEach.call(all, function (b) { b.remove(); });
  }

  function block(on) {
    var targets = document.querySelectorAll(
      DRAWER_WRAPPER + ',' + CART_SIDEBAR + ' [name="checkout"]');
    Array.prototype.forEach.call(targets, function (el) {
      el.classList.toggle('ff-avail-blocked', !!on);
      var btns = el.querySelectorAll
        ? el.querySelectorAll('button,input[type="submit"]') : [];
      Array.prototype.forEach.call(btns, function (b) {
        b.disabled = !!on;
        b.setAttribute('aria-disabled', on ? 'true' : 'false');
      });
      if (el.matches && el.matches('[name="checkout"]')) {
        el.disabled = !!on;
        el.setAttribute('aria-disabled', on ? 'true' : 'false');
      }
    });
  }

  function bannerHTML(items) {
    var rows = items.map(function (it) {
      var where = it.missing_at && it.missing_at.length
        ? '<span class="ff-avail-where">Not in stock at '
          + esc(it.missing_at.join(', ')) + '</span>' : '';
      return '<li><span class="ff-avail-name">' + esc(it.display_name)
        + '</span>' + where
        + '<button type="button" class="ff-avail-remove" data-remove="'
        + it.variant_id + '">Remove this item</button></li>';
    }).join('');

    return '<div id="' + BANNER_ID + '" class="ff-avail">'
      + '<b>Some items are not available for your delivery area</b>'
      + '<ul>' + rows + '</ul>'
      + '<p class="ff-avail-foot">Remove them, or choose an alternative, '
      + 'to continue to checkout.</p></div>';
  }

  function paint(items) {
    removeBanners();
    if (!items.length) { block(false); return; }

    var html = bannerHTML(items);

    /* Cart page: top of the sidebar, right above Subtotal and the button. */
    var sidebar = document.querySelector(CART_SIDEBAR);
    if (sidebar) sidebar.insertAdjacentHTML('afterbegin', html);

    /* Cart drawer: directly above the checkout button. */
    var wrapper = document.querySelector(DRAWER_WRAPPER);
    if (wrapper) wrapper.insertAdjacentHTML('beforebegin', html);

    block(true);

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-remove]'), function (btn) {
        btn.addEventListener('click', function () {
          btn.disabled = true;
          btn.textContent = 'Removing…';
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.remove, quantity: 0 })
          }).then(function () { window.location.reload(); });
        });
      });
  }

  /* ---------------------------------------------------------------- run */
  function run() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { removeBanners(); block(false); return; }
        var ids = cart.items.map(function (i) { return i.variant_id || i.id; });
        return load(ids, postcodeFrom(cart)).then(function (map) {
          paint(ids.map(function (id) { return map[id]; })
                   .filter(Boolean));
        });
      })
      .catch(function () { /* never break the cart */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Repaint when either surface redraws.

     The theme replaces cart DOM wholesale (cart-provider.js _updateContent),
     which removes the banner, and the drawer is only populated when it opens -
     after this script has already run. Its internal pub/sub is not reachable
     from here, so both surfaces are watched directly. A MutationObserver on
     body catches the drawer appearing, the cart page redrawing, and Zapiet
     writing its postcode, without depending on theme internals. */
  var repaint = null;
  function scheduleRun() {
    clearTimeout(repaint);
    repaint = setTimeout(run, 300);
  }

  try {
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (!r.addedNodes || !r.addedNodes.length) continue;
          for (var j = 0; j < r.addedNodes.length; j++) {
            var n = r.addedNodes[j];
            if (n.nodeType !== 1) continue;
            /* Only react when a cart surface appears or redraws. */
            if (n.matches && (n.matches(CART_SIDEBAR) || n.matches(DRAWER_WRAPPER))) {
              scheduleRun(); return;
            }
            if (n.querySelector &&
                n.querySelector(CART_SIDEBAR + ',' + DRAWER_WRAPPER)) {
              scheduleRun(); return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  } catch (e) {}

  /* Zapiet writes the postcode to cart attributes when the customer checks
     their area. Watching its field means the banner corrects itself to their
     own hub as soon as they enter one, instead of reporting another metro. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.tagName === 'INPUT' && /post|zip/i.test(
        (t.name || '') + (t.id || '') + (t.placeholder || ''))) {
      setTimeout(run, 800);   /* let Zapiet save the attribute first */
    }
  }, true);
})();
